import _ from "lodash"

export const DROP_CONTAINERS = new Set(["first", "second"])

export const buildDefaultContainers = (unassignedItems) => ({
    first: [],
    second: [],
    unassigned: unassignedItems,
})

export const findContainerId = (containers, itemId) =>
    Object.keys(containers).find((key) =>
        containers[key].some((item) => item.id === itemId)
    )

export const findItem = (containers, itemId) => {
    const containerId = findContainerId(containers, itemId)
    if (!containerId) return null
    return containers[containerId].find((item) => item.id === itemId)
}

export const computeDroppedPosition = (activeRect, overRect) => {
    if (!activeRect || !overRect) return {}

    const x = Math.max(0, Math.min(activeRect.left - overRect.left, overRect.width - 96))
    const y = Math.max(0, Math.min(activeRect.top - overRect.top, overRect.height - 96))

    return { x, y }
}

export const stripPlacementData = (item) => _.omit(item, ["x", "y", "answers"])

export const moveItem = (containers, itemId, fromId, toId, patchItem) => {
    if (fromId === toId) {
        return {
            ...containers,
            [fromId]: containers[fromId].map((item) =>
                item.id === itemId ? patchItem(item) : item
            ),
        }
    }

    return {
        ...containers,
        [fromId]: containers[fromId].filter((item) => item.id !== itemId),
        [toId]: [...containers[toId], patchItem(containers[fromId].find((i) => i.id === itemId))],
    }
}

export const getLabelByItem = (item) => item?.answerAsLabel ? item?.answers?.[item?.answerKey] : item?.label